import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

const useTabletLayout = () => {
  const dispatch = useDispatch();
  const ready = useSelector( state => state.user );
  const isTablet = useSelector( state => state.layoutTablet );
  const isEnabled = useSelector ( state => (state.isConnected && state.isSubscribed) )

  const enableElements = (elements = [], state) => {
    elements.forEach( x => {
      const el = document.getElementById(x);
      if (el) {
        el.style.display = state ? `initial` : `none`
      }
    });
  }
  const disableElements = (elements = [], state) => {
    elements.forEach( x => {
      const el = document.getElementById(x);
      if (el) {
        el.style.display = state ? `none` : `block`
      }
    });
  }
  const tabletElements = (elements = [], state) => {
    elements.forEach( x => {
      const el = document.getElementById(x);
      if (el) {
        if (state) {
          document.getElementById(x).classList.add(`tablet`);
        } else {
          document.getElementById(x).classList.remove(`tablet`);
        }
      }
    });
  }

  useEffect(() => {
    if (ready && isEnabled && window['YouDJ'] && (window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0)) {
      // Touch Layout + Cursor
      const touchHandler = (event) => {
        const touch = event.changedTouches[0];
        let type = "mousemove";
        let clickEvent = document.createEvent("MouseEvent");
        let clientX = touch.clientX;
        let clientY = touch.clientY;
        let screenX = touch.screenX;
        let screenY = touch.screenY;
        clickEvent.initMouseEvent(type, true, true, window, 1, screenX, screenY, clientX, clientY, false, false, false, false, 0, null);
        touch.target.dispatchEvent(clickEvent);
        event.preventDefault();
      }
      document.getElementById(`player`).addEventListener('touchstart', touchHandler, true)
      document.getElementById(`player`).addEventListener('touchend', touchHandler, true)
      document.getElementById(`player`).addEventListener('touchmove', touchHandler, true)

      // Prevent Pinch Zoom when multi-touch
      document.getElementById(`player`).addEventListener('wheel', (e) => {
        if (window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0) {
          e.preventDefault();
        }
      }, true);

    }
  }, [ready, isEnabled, dispatch])

  useEffect(() => {
    // REPOSITIONING
    [...document.querySelectorAll(`.eqa`)].forEach( x => {
      if (isTablet) { x.classList.add(`tablet`) } else { x.classList.remove(`tablet`) }
    } );
    [...document.querySelectorAll(`.eqb`)].forEach( x => {
      if (isTablet) { x.classList.add(`tablet`) } else { x.classList.remove(`tablet`) }
    } );
    [...document.querySelectorAll(`.butpro`)].forEach( x => {
      if (isTablet) { x.classList.add(`tablet`) } else { x.classList.remove(`tablet`) }
    } );
    [...document.querySelectorAll(`.pro_board_clip`)].forEach( x => {
      if (isTablet) { x.classList.add(`tablet`) } else { x.classList.remove(`tablet`) }
    } );

    tabletElements([
      `gain1`, `kill11`, `kill12`, `kill13`, `kill14`, `gain2`, `kill21`, `kill22`, `kill23`, `kill24`,
      `fader1`, `vumeter-container1`, `headphone1`, `fader2`, `vumeter-container2`, `headphone2`, `wave_content`,
      `bpm1`, `rate1`, `bpm2`, `rate2`, `loop1`, `sfx1_toggle`, `loop2`, `sfx2_toggle`,
      `vinyl1`, `vinyl2`, `backspin1`, `backspin2`, `play1`, `play2`, `cue1`, `cue2`,
      `bbox1`, `bbox2`, `crossfader`, `arrow1`, `arrow2`, `beatvisu`, `pro1_sync`, `pro2_sync`, `bpm_button`,
      `wave1_bp`, `wave2_bp`, `wave_area1`, `wave_area2`,
      `wave_edit1`, `wave_edit2`, `wave_editor1`, `wave_editor2`,
      `wave_zoom+`, `wave_zoom-`
    ], isTablet)

    disableElements([
      `pitch1`, `pitch2`,
      `p1_bend_minus`, `p1_bend_plus`,
      `p1_bend_minus`, `p1_bend_plus`, `p2_bend_minus`, `p2_bend_plus`,
      `loopC1_plus`, `loopA1_minus`, `loopC2_plus`, `loopA2_minus`,
      `pro1_pitch_inc-`, `pro2_pitch_inc-`, `pro1_pitch_inc+`, `pro2_pitch_inc+`,
      `pro1_hotcue7`,`pro1_hotcue8`, `pro2_hotcue7`,`pro2_hotcue8`,
      `wave_edit1`, `wave_edit2`, `wave_zoom-`, `wave_zoom+`
    ], isTablet)
    enableElements([
      `p1_bend_minus_touch`, `p1_bend_plus_touch`, `p2_bend_minus_touch`, `p2_bend_plus_touch`,
      `loopC1_plus_touch`, `loopA1_minus_touch`, `loopC2_plus_touch`, `loopA2_minus_touch`,
    ], isTablet)

    //window.player_get(1).jump_resize(515 - 9); // NOT ACCESSIBLE ...

  }, [isTablet])

  return null;
};

export default useTabletLayout;
